import React, { useState } from 'react';
import '../styles/SchemesPage.css';
import VyapariImg from '../assets/photos/vyapari-scheme.png';
import SuvasiniImg from '../assets/photos/suvasini-scheme.png';
import SukhakartaImg from '../assets/photos/sukhakarta-scheme.png';
import NavudyojakImg from '../assets/photos/navudyojak-scheme.png';
import VyapariSchemeBanner from '../assets/photos/vyapari-scheme-banner.png';
import SuvaseneBanner from '../assets/photos/suvasene.png';
import SukhakartaBanner from '../assets/photos/sukhakarta-banner.jpg';
import NavudyojakBanner from '../assets/photos/navudyojak-banner.png';
import MahalaxmiImg from '../assets/photos/mahalaxmi-scheme.png';
import MahalaxmiBanner from '../assets/photos/mahalaxmi-banner.png';

// ─────────────────────────────────────────────────────────────────
// SCHEMES LIST DATA
// ✏️ To add a new scheme card → add a new object in this array
// ─────────────────────────────────────────────────────────────────

const schemes = [
  {
    id: 'vyapari',
    name: 'Sahyadri Vyapari Scheme',
    desc: 'Cash credit limit facility for small traders, shopkeepers and retailers.',
    cardImage:VyapariImg,
    imgPosition: 'center center',
    tags: [
      { label: 'CC Limit', color: 'blue' },
      { label: 'Traders', color: 'orange' },
    ],
    interest: '9.50% p.a.',
  },
  {
    id: 'suvasini',
    name: 'Suvasini Gharkul Scheme',
    desc: 'Home loan scheme specially designed for women borrowers.',
    cardImage: SuvasiniImg,
    imgPosition: 'center 25%',
    tags: [
      { label: 'Home Loan', color: 'blue' },
      { label: 'Women', color: 'green' },
    ],
    interest: '9.25% p.a.',
  },
  {
    id: 'sukhakarta',
    name: 'Sukhakarta Thev Yojana',
    desc: 'Special festive fixed deposit scheme with attractive monthly interest payout.',
    cardImage: SukhakartaImg,
    imgPosition: 'center center',
    tags: [
      { label: 'Fixed Deposit', color: 'blue' },
      { label: 'Festive Offer', color: 'orange' },
    ],
    interest: '7.55% p.a.',
  },
  {
    id: 'navudyojak',
    name: 'Sahyadri Navudyojak',
    desc: 'MSME advances scheme for Working Capital (CC Limit) and Purchase of Machinery, for existing and new customers.',
    cardImage: NavudyojakImg,
    imgPosition: 'center center',
    tags: [
      { label: 'CC Limit', color: 'blue' },
      { label: 'Machinery Loan', color: 'orange' },
    ],
    interest: '10% p.a.',
  },
  {
  id: 'mahalaxmi',
  name: 'Mahalaxmi Thev Yojna',
  desc: 'Special Navratri festive fixed deposit scheme with attractive monthly interest payout.',
  cardImage: MahalaxmiImg,
  imgPosition: 'center center',
  tags: [
    { label: 'Fixed Deposit', color: 'blue' },
    { label: 'Navratri Festival Scheme', color: 'orange' },
  ],
  interest: '7.60% p.a.',
  },
  
];

// ─────────────────────────────────────────────────────────────────
// VYAPARI SCHEME DATA
// ✏️ Edit any row below to update the detail page content
// ─────────────────────────────────────────────────────────────────

const vyapariFeatures = [
  { label: 'Eligible borrower', value: 'Small trader / shopkeeper / retailer' },
  { label: 'Area jurisdiction', value: 'Shop location strictly within branch area' },
  { label: 'Type', value: 'CC Facility (New / Takeover)' },
  { label: 'Terms', value: 'Renewable every 12 months or repayable on demand' },
  { label: 'Rate of interest', value: '9.50% p.a. (payable at monthly rest)' },
  { label: 'DP / Limit calculation', value: '80% of stock value and debtors net of creditors' },
  { label: 'Margin', value: '20% of stock value' },
  { label: 'Stock statement', value: 'Monthly before 25th of every month' },
  { label: 'Stock verification', value: 'Branch manager monthly visit mandatory' },
];

const vyapariSecurity = [
  { label: 'Prime security', value: 'Hypothecation of stock (trading items)' },
  {
    label: 'Collateral security',
    value:
      'NSC / LIC / Fixed deposit receipt of this bank / Property (except land). Surrender or realisable value minimum 100% of sanction amount.',
  },
];

const vyapariPenalty = [
  { label: 'Default penalty', value: '2% p.a. for defaulted period on defaulted amount' },
  {
    label: 'Non-submission of stock statement',
    value: '2% p.a. on outstanding balance till submission of stock statement',
  },
];

const vyapariDocuments = [
  'Loan application form',
  'CIBIL assessment (mandatory)',
  'KYC documents of proprietor / partners',
  'Udyam Aadhar',
  'GST certificate (if applicable)',
  'Self certified stock statement',
  'Existing current account bank statement (latest 12 months)',
  'Collateral security — LIC / NSC / fixed deposit receipt',
  'Registered partnership deed (if partnership firm)',
  'In case of takeover: foreclosure letter, list of documents, confidential report and one year statement',
];

const vyapariBanking = [
  { label: 'Banking', value: 'Exclusive banking mandatory. No account with any other bank allowed.' },
  { label: 'Closure of other bank account', value: 'Before disbursement of CC account' },
  { label: 'Turnover condition', value: 'Entire turnover to be routed through CC account only' },
  {
    label: 'Insurance',
    value:
      "Stock to be insured from borrower's own funds. Insurance copy with bank hypothecation clause to be submitted.",
  },
  { label: 'Credit shield', value: 'Applicant advised to insure with credit shield for duration of the limit' },
];

// ─────────────────────────────────────────────────────────────────
// SUVASINI SCHEME DATA
// ✏️ Edit any row below to update the detail page content
// ─────────────────────────────────────────────────────────────────

const suvasiniFeatures = [
  { label: 'Eligible borrower', value: 'Women borrowers aged 21 years and above with stable employment or business income' },
  { label: 'CIBIL score', value: 'Minimum 750 and above' },
  { label: 'Loan amount', value: '₹10 Lacs to ₹1.40 Crore' },
  { label: 'Rate of interest', value: '9.25% p.a.' },
  { label: 'Maximum repayment tenure', value: '20 years for salaried class / professionals' },
  { label: 'Type', value: 'Home loan — purchase / construction of residential property' },
];

const suvasiniMargin = [
  { label: 'Loan upto ₹35 Lacs', value: '15% of agreement value or market value, whichever is lower' },
  {
    label: 'Loan above ₹35 Lacs',
    value: '15% of agreement value + stamp duty + registration charges, or market value, whichever is lower',
  },
];

const suvasiniProcess = [
  { label: 'Step 1 — Application', value: 'Submit loan application with property and income documents' },
  { label: 'Step 2 — Evaluation', value: 'Income assessment, CIBIL check and property verification carried out by bank' },
  { label: 'Step 3 — Sanction', value: 'Loan sanctioned after successful evaluation and credit assessment' },
  { label: 'Step 4 — Disbursement', value: 'Amount released as per construction stage or seller agreement' },
];

const suvasiniSecurity = [
  { label: 'Prime security', value: 'Mortgage of residential premises to be purchased / constructed' },
];

const suvasiniDocuments = [
  'Loan application form',
  'CIBIL assessment (mandatory — score 750 and above)',
  'KYC documents — Aadhaar, PAN card',
  'Income proof — salary slips / ITR / Form 16',
  'Bank statement (latest 12 months)',
  'Property documents — agreement, title deed, approved plan',
  'Valuation report of property',
  'Stamp duty and registration documents',
  'Employer certificate (for salaried applicants)',
  'Business proof (for self-employed applicants)',
];

const suvasiniBanking = [
  { label: 'Eligibility condition', value: 'Loan applicant must be a woman borrower. Co-applicant may be permitted as per bank norms.' },
  { label: 'Repayment mode', value: 'EMI via post-dated cheques or NACH mandate' },
  {
    label: 'Insurance',
    value: 'Property to be insured against fire and other risks. Insurance copy with bank mortgage clause to be submitted.',
  },
  { label: 'Credit shield', value: 'Applicant advised to insure with credit shield for the duration of the loan' },
];

// ─────────────────────────────────────────────────────────────────
// SUKHAKARTA THEV YOJNA SCHEME DATA
// ✏️ Edit any row below to update the detail page content
// ─────────────────────────────────────────────────────────────────

const sukhakartaFeatures = [
  { label: 'Scheme name', value: 'Sukhakarta Thev Yojana' },
  { label: 'Minimum deposit', value: '₹5,000/-' },
  { label: 'Deposit period', value: '21 Months' },
  { label: 'Scheme period', value: '1st August 2026 to 30th September 2026' },
  { label: 'Rate of interest', value: '7.55% p.a. (Simple Interest)' },
  { label: 'Interest payout', value: 'Monthly (credited to depositor account)' },
  { label: 'Targeted customer base', value: 'Individual / Firms / HUF / Trust / Credit Society / Housing Society / Senior Citizens' },
];

const sukhakartaTerms = [
  { label: 'Pre-mature closure', value: 'Not allowed under this scheme' },
  { label: 'Loan / OD facility', value: 'Available against such Fixed Deposit' },
  { label: 'Funding available', value: 'Upto 95% of Principal Amount of the Deposit' },
  { label: 'TDS', value: 'To be deducted as per Income Tax rule' },
];

const sukhakartaDocuments = [
  'Deposit account should be fully KYC complied as per the Guidelines',
];



// ─────────────────────────────────────────────────────────────────
// SAHYADRI NAVUDYOJAK SCHEME DATA
// ✏️ Source: Circular No. 42, dated 01/08/2026
// ✏️ Edit any row below to update the detail page content
// ─────────────────────────────────────────────────────────────────

const navudyojakFeatures = [
  { label: 'Scheme name', value: 'Sahyadri Navudyojak — For Existing and New customers' },
  { label: 'Purpose', value: 'Working Capital Limit (Cash Credit) and Purchase of Machinery (New / Pre-owned)' },
  { label: 'CC Limit tenure', value: 'Renewal every year. Monthly interest payable.' },
  { label: 'Machinery Term Loan tenure', value: 'Maximum repayment period 60 months. Monthly EMI basis.' },
  { label: 'Rate of interest (ROI)', value: '10% p.a. or as decided by ALCO / Board from time to time' },
  {
    label: 'Income criteria',
    value:
      'Existing businessman: minimum net profit ₹4 Lacs for latest financial year, and 3 times average cash accruals for latest 3 years. OR latest financial year net cash accrual with proper justification. OR for new start-up: CA certified provisional financials and CMA report required.',
  },
  {
    label: 'Moratorium',
    value:
      'For purchase of machinery — 6 months or upto machinery installation / start of production activity, whichever is earlier. Interest to be serviced every month during the moratorium period.',
  },
  { label: 'Maximum limit', value: '₹50 Lacs (CC limit 20% of turnover, actual / projected)' },
];

const navudyojakMargin = [
  {
    label: 'Working Capital Limit',
    value: '30% margin of Stock (Plus) Receivables (within 90 days) (Less) Creditors. Drawing Power calculated every month; stock statement to be submitted before 10th of every month.',
  },
  { label: 'Purchase of Machinery — New', value: '20% margin (as per quotation)' },
  { label: 'Purchase of Machinery — Pre-owned', value: '50% margin (maximum 3 years old, as per valuation, as per Credit Policy)' },
];

const navudyojakSecurity = [
  { label: 'Primary security — Working Capital', value: 'Hypothecation of stock and debtors' },
  { label: 'Primary security — Machinery Loan', value: 'Hypothecation of machinery' },
  {
    label: 'Collateral security',
    value:
      'Minimum 50% of sanctioned amount. Available cushion: Property — 60% of realisable value; LIC / Govt Securities — 80% of surrender value; Bank FD — 95% of value.',
  },
  {
    label: 'Legal',
    value: "Satisfactory clear and valid, marketable title and search report must be obtained from Bank's panel advocate, in case property is mortgaged as collateral security.",
  },
  { label: 'CERSAI registration', value: 'Bank charge to be created on CERSAI portal, and report to be preserved for audit verification purpose.' },
];

const navudyojakSurety = [
  { label: 'Surety requirement', value: 'One surety with good CIBIL score and satisfactory repayment track record' },
  { label: 'Businessman surety — income criteria', value: 'Minimum ₹3 Lacs p.a.' },
  { label: 'Salaried class surety — income criteria', value: 'Minimum take-home salary ₹25,000/- p.m. or as decided by Board from time to time' },
  { label: 'Membership / Share linking', value: 'Regular membership required. Share linking 2.5% of loan amount sanctioned. Surety should also be a Regular or Nominal member of the Bank.' },
];

const navudyojakPenalty = [
  { label: 'Penal charges', value: '2% p.a. penal charges will be charged on defaulted amount for defaulted period' },
];

const navudyojakDocumentsBorrower = [
  'Machinery quotation from Authorised Dealer (for purchase of machinery)',
  'Stock statement as per Bank format (for Working Capital / CC Limit)',
  'ITR filed copy with computation of income, Balance Sheet, Profit & Loss A/c and other relevant tax paid challan for consecutive 3 years',
  'Udyam Registration certificate',
  'Leave & License agreement (Registered)',
  'Electricity bill of factory / firm',
  'GST registration certificate / GST returns for financial year',
  'Any other applicable documents related to business',
  'Proprietor / Director / Partners — KYC documents, 1 photograph, 3 years audited / CA certified ITR with P&L and Balance Sheet, bank statement of 1 year',
];

const navudyojakDocumentsSurety = [
  'For Businessman — KYC documents, 1 photograph, 3 years audited / CA certified ITR with P&L and Balance Sheet, bank statement of 1 year, Udyam Registration certificate, Leave & License agreement (registered), electricity bill of factory / firm, GST registration certificate / GST returns, any other applicable business documents',
  "For Salaried (Permanent employee) — KYC documents along with 1 photograph, 3 months' salary slip, 6 months bank statement, appointment letter / confirmation letter",
];

const navudyojakBanking = [
  { label: 'Purpose classification', value: 'Priority or non-priority purpose (end use verification and proof to be obtained)' },
  { label: 'Processing fee', value: "As per Bank's prescribed service charges" },
  {
    label: 'Disbursement — Working Capital',
    value: 'CC limit to be disbursed and cheque book to be given for business transaction. 100% turnover to be routed through the CC Limit account.',
  },
  {
    label: 'Disbursement — Machinery',
    value: 'Direct payment to vendor / contractor / financer / seller, or reimbursement in case of production of payment receipt / cash memo / bills and bank account entry.',
  },
  {
    label: 'End use verification',
    value: 'End use of funds shall be verified before and after disbursement. Branch to obtain valid proof for end use verification. Inspection / visit report along with photographs should be kept on record.',
  },
  {
    label: 'Other requirements',
    value:
      "Passport size photograph of applicant & sureties; copy of I.D. card; visit reports of office / business premises and residence of applicant & sureties; bank statement for last 12 months; CIBIL compulsory; confidential report of other bank if applicable; insurance copy with bank hypothecation clause at borrower's cost.",
  },
];

// ─────────────────────────────────────────────────────────────────
// MAHALAXMI THEV YOJANA SCHEME DATA
// Source: scheme banner
// ─────────────────────────────────────────────────────────────────

const mahalaxmiFeatures = [
  { label: 'Scheme name', value: 'Mahalaxmi Thev Yojana' },
  { label: 'Rate of interest', value: '7.60% p.a.' },
  { label: 'Deposit period', value: '21 Months' },
  { label: 'Scheme period', value: '9th October 2026 to 30th November 2026' },
  { label: 'Loan facility', value: 'Available' },
];

// ─────────────────────────────────────────────────────────────────
// REUSABLE SUB COMPONENTS
// ─────────────────────────────────────────────────────────────────

const SpFeatureRows = ({ data }) => (
  <>
    {data.map((item, i) => (
      <div key={i} className="sp-feature-row">
        <div className="sp-f-label">{item.label}</div>
        <div className="sp-f-value">{item.value}</div>
      </div>
    ))}
  </>
);

const SpDocList = ({ items }) => (
  <>
    {items.map((doc, i) => (
      <div key={i} className="sp-doc-item">
        <div className="sp-doc-dot"></div>
        <div>{doc}</div>
      </div>
    ))}
  </>
);

const SpSchemeCard = ({ scheme, onClick }) => (
  <div className="sp-scheme-card" onClick={onClick}>
    <div className="sp-card-top-bar"></div>
    <div className="sp-card-img-wrapper">
      <img
        src={scheme.cardImage}
        alt={scheme.name}
        className="sp-card-img"
        style={{ objectPosition: scheme.imgPosition }}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
      <div className="sp-card-img-placeholder">
        <div className="sp-placeholder-icon">{scheme.icon}</div>
        <div className="sp-placeholder-text">{scheme.placeholderText}</div>
      </div>
    </div>
    <div className="sp-card-body">
      <div className="sp-scheme-name">{scheme.name}</div>
      <div className="sp-scheme-desc">{scheme.desc}</div>
      <div className="sp-scheme-tags">
        {scheme.tags.map((tag, i) => (
          <span key={i} className={`sp-tag sp-tag-${tag.color}`}>
            {tag.label}
          </span>
        ))}
      </div>
      <div className="sp-scheme-footer">
        <div className="sp-scheme-rate">
          Interest: <span>{scheme.interest}</span>
        </div>
        <div className="sp-view-btn">View details →</div>
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────
// VYAPARI DETAIL PAGE
// ─────────────────────────────────────────────────────────────────

const VyapariDetail = ({ onBack }) => (
  <div className="sp-detail-page">

    {/* HERO — full width */}
    <div className="sp-detail-hero-wrapper">
      <button className="sp-back-btn" onClick={onBack}>← Back to all schemes</button>
      <div>
        <div className="sp-badge">Circular No. __ &nbsp;|&nbsp; Effective 1 May 2026</div>
      </div>
      <h1 className="sp-detail-title">Sahyadri Vyapari Scheme</h1>
      <p className="sp-detail-subtitle">
        Cash credit limit facility for small traders, shopkeepers and retailers.
        Approved vide BOD meeting dated 22nd April 2026.
      </p>
    </div>

    {/* CONTENT */}
    <div className="sp-detail-content">

      <img
        src={VyapariSchemeBanner}
        alt="Sahyadri Vyapari Scheme Banner"
        className="sp-banner-img"
        onError={(e) => (e.target.style.display = 'none')}
      />

      {/* METRICS */}
      <div className="sp-metrics-grid">
        <div className="sp-metric-card">
          <div className="sp-metric-label">Maximum limit</div>
          <div className="sp-metric-value">₹10 Lacs</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Rate of interest</div>
          <div className="sp-metric-value">9.50% p.a.</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Renewal period</div>
          <div className="sp-metric-value">12 months</div>
        </div>
      </div>

      {/* SCHEME FEATURES */}
      <div className="sp-section-card">
        <div className="sp-section-title">Scheme features</div>
        <SpFeatureRows data={vyapariFeatures} />
      </div>

      {/* SECURITY */}
      <div className="sp-section-card">
        <div className="sp-section-title">Security</div>
        <SpFeatureRows data={vyapariSecurity} />
      </div>

      {/* PENALTY */}
      <div className="sp-section-card">
        <div className="sp-section-title">Penalty</div>
        <SpFeatureRows data={vyapariPenalty} />
      </div>

      {/* DOCUMENTATION */}
      <div className="sp-section-card">
        <div className="sp-section-title">Documentation required</div>
        <SpDocList items={vyapariDocuments} />
      </div>

      {/* BANKING & CONDITIONS */}
      <div className="sp-section-card">
        <div className="sp-section-title">Banking & other conditions</div>
        <SpFeatureRows data={vyapariBanking} />
      </div>

       {/* APPLY BUTTON */}
       <div className="sp-apply-wrapper">
         <a href="/loan-enquiry" className="sp-apply-btn">Apply Now</a>
       </div>

      {/* NOTE */}
      <div className="sp-note-box">
        ℹ️ Bank reserves the right to review or withdraw the facility at any time without giving
        any reason. Branches are requested to market this scheme to traders and shopkeepers
        within the branch vicinity. Scheme is applicable with effect from 1st May 2026.
      </div>

    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────
// SUVASINI DETAIL PAGE
// ─────────────────────────────────────────────────────────────────

const SuvasiniDetail = ({ onBack }) => (
  <div className="sp-detail-page">

    {/* HERO — full width */}
    <div className="sp-detail-hero-wrapper">
      <button className="sp-back-btn" onClick={onBack}>← Back to all schemes</button>
      <div>
        <div className="sp-badge">Suvasini Gharkul Scheme &nbsp;|&nbsp; Effective 1 Jan 2026</div>
      </div>
      <h1 className="sp-detail-title">Suvasini Gharkul Scheme</h1>
      <p className="sp-detail-subtitle">
        Home loan scheme specially designed for women borrowers.
        Own your dream home with affordable rates and longer tenure.
      </p>
    </div>

    {/* CONTENT */}
    <div className="sp-detail-content">

      <img
        src={SuvaseneBanner}
        alt="Suvasini Gharkul Scheme Banner"
        className="sp-banner-img"
        onError={(e) => (e.target.style.display = 'none')}
      />

      {/* METRICS */}
      <div className="sp-metrics-grid">
        <div className="sp-metric-card">
          <div className="sp-metric-label">Maximum loan amount</div>
          <div className="sp-metric-value">₹1.40 Crore</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Rate of interest</div>
          <div className="sp-metric-value">9.25% p.a.</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Maximum tenure</div>
          <div className="sp-metric-value">20 years</div>
        </div>
      </div>

      {/* SCHEME FEATURES */}
      <div className="sp-section-card">
        <div className="sp-section-title">Scheme features</div>
        <SpFeatureRows data={suvasiniFeatures} />
      </div>

      {/* MARGIN */}
      <div className="sp-section-card">
        <div className="sp-section-title">Margin</div>
        <SpFeatureRows data={suvasiniMargin} />
      </div>

      {/* PROCESS */}
      <div className="sp-section-card">
        <div className="sp-section-title">Loan process</div>
        <SpFeatureRows data={suvasiniProcess} />
      </div>

      {/* SECURITY */}
      <div className="sp-section-card">
        <div className="sp-section-title">Security</div>
        <SpFeatureRows data={suvasiniSecurity} />
      </div>

      {/* DOCUMENTATION */}
      <div className="sp-section-card">
        <div className="sp-section-title">Documentation required</div>
        <SpDocList items={suvasiniDocuments} />
      </div>

      {/* OTHER CONDITIONS */}
      <div className="sp-section-card">
        <div className="sp-section-title">Other conditions</div>
        <SpFeatureRows data={suvasiniBanking} />
      </div>

      {/* APPLY BUTTON */}
      <div className="sp-apply-wrapper">
        <a href="/loan-enquiry" className="sp-apply-btn">Apply Now</a>
      </div>

      {/* NOTE */}
      <div className="sp-note-box">
        ℹ️ This scheme is exclusively available for women borrowers. Bank reserves the right to
        review or withdraw the facility at any time without giving any reason. Loan approval is
        subject to repayment capacity, credit assessment and property verification.
        For more information please contact your nearest branch manager.
      </div>

    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────
// SUKHAKARTA THEV YOJNA DETAIL PAGE
// ─────────────────────────────────────────────────────────────────

const SukhakartaDetail = ({ onBack }) => (
  <div className="sp-detail-page">

    {/* HERO — full width */}
    <div className="sp-detail-hero-wrapper">
      <button className="sp-back-btn" onClick={onBack}>← Back to all schemes</button>
      <div>
        <div className="sp-badge">Circular No. 41 &nbsp;|&nbsp; Effective 1 August 2026</div>
      </div>
      <h1 className="sp-detail-title">Sukhakarta Thev Yojana</h1>
      <p className="sp-detail-subtitle">
        Special festive fixed deposit scheme introduced to strengthen the Bank's deposit base,
        launched to coincide with the Ganesh Chaturthi festive season.
      </p>
    </div>

    {/* CONTENT */}
    <div className="sp-detail-content">

      <img
        src={SukhakartaBanner}
        alt="Sukhakarta Thev Yojna Banner"
        className="sp-banner-img"
        onError={(e) => (e.target.style.display = 'none')}
      />

      {/* METRICS */}
      <div className="sp-metrics-grid">
        <div className="sp-metric-card">
          <div className="sp-metric-label">Minimum deposit</div>
          <div className="sp-metric-value">₹5,000/-</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Rate of interest</div>
          <div className="sp-metric-value">7.55% p.a.</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Deposit period</div>
          <div className="sp-metric-value">21 Months</div>
        </div>
      </div>

      {/* SCHEME FEATURES */}
      <div className="sp-section-card">
        <div className="sp-section-title">Scheme features</div>
        <SpFeatureRows data={sukhakartaFeatures} />
      </div>

      {/* TERMS */}
      <div className="sp-section-card">
        <div className="sp-section-title">Pre-mature closure & funding terms</div>
        <SpFeatureRows data={sukhakartaTerms} />
      </div>

      {/* DOCUMENTATION */}
      <div className="sp-section-card">
        <div className="sp-section-title">Documentation required</div>
        <SpDocList items={sukhakartaDocuments} />
      </div>


      {/* APPLY BUTTON */}
      <div className="sp-apply-wrapper">
        <a href="/loan-enquiry" className="sp-apply-btn">Apply Now</a>
      </div>

      {/* NOTE */}
      <div className="sp-note-box">
        ℹ️ Pre-mature closure is not allowed under this scheme, however loan / OD facility against
        such Fixed Deposit is available upto 95% of the principal amount. TDS will be deducted as
        per Income Tax rules. Scheme is applicable from 1st August 2026 to 30th September 2026.
      </div>

    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────
// SAHYADRI NAVUDYOJAK DETAIL PAGE
// ─────────────────────────────────────────────────────────────────

const NavudyojakDetail = ({ onBack }) => (
  <div className="sp-detail-page">

    {/* HERO — full width */}
    <div className="sp-detail-hero-wrapper">
      <button className="sp-back-btn" onClick={onBack}>← Back to all schemes</button>
      <div>
        <div className="sp-badge">Circular No. 42 &nbsp;|&nbsp; Effective 1 August 2026</div>
      </div>
      <h1 className="sp-detail-title">Sahyadri Navudyojak</h1>
      <p className="sp-detail-subtitle">
        MSME advances scheme for Working Capital (CC Limit) and Purchase of Machinery,
        for existing and new customers. Approved vide Board meeting dated 28th July 2026.
      </p>
    </div>

    {/* CONTENT */}
    <div className="sp-detail-content">

      <img
        src={NavudyojakBanner}
        alt="Sahyadri Navudyojak Scheme Banner"
        className="sp-banner-img"
        onError={(e) => (e.target.style.display = 'none')}
      />

      {/* METRICS */}
      <div className="sp-metrics-grid">
        <div className="sp-metric-card">
          <div className="sp-metric-label">Maximum limit</div>
          <div className="sp-metric-value">₹50 Lacs</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Rate of interest</div>
          <div className="sp-metric-value">10% p.a.</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Machinery loan tenure</div>
          <div className="sp-metric-value">60 months</div>
        </div>
      </div>

      {/* SCHEME FEATURES */}
      <div className="sp-section-card">
        <div className="sp-section-title">Scheme features</div>
        <SpFeatureRows data={navudyojakFeatures} />
      </div>

      {/* MARGIN */}
      <div className="sp-section-card">
        <div className="sp-section-title">Margin</div>
        <SpFeatureRows data={navudyojakMargin} />
      </div>

      {/* SECURITY */}
      <div className="sp-section-card">
        <div className="sp-section-title">Security</div>
        <SpFeatureRows data={navudyojakSecurity} />
      </div>

      {/* SURETY & MEMBERSHIP */}
      <div className="sp-section-card">
        <div className="sp-section-title">Surety & membership</div>
        <SpFeatureRows data={navudyojakSurety} />
      </div>

      {/* PENALTY */}
      <div className="sp-section-card">
        <div className="sp-section-title">Penalty</div>
        <SpFeatureRows data={navudyojakPenalty} />
      </div>

      {/* DOCUMENTATION — BORROWER */}
      <div className="sp-section-card">
        <div className="sp-section-title">Documentation required (Borrower)</div>
        <SpDocList items={navudyojakDocumentsBorrower} />
      </div>

      {/* DOCUMENTATION — SURETY */}
      <div className="sp-section-card">
        <div className="sp-section-title">Documentation required (Surety)</div>
        <SpDocList items={navudyojakDocumentsSurety} />
      </div>

      {/* BANKING & CONDITIONS */}
      <div className="sp-section-card">
        <div className="sp-section-title">Disbursement & other conditions</div>
        <SpFeatureRows data={navudyojakBanking} />
      </div>

      {/* APPLY BUTTON */}
      <div className="sp-apply-wrapper">
        <a href="/loan-enquiry" className="sp-apply-btn">Apply Now</a>
      </div>

      {/* NOTE */}
      <div className="sp-note-box">
        ℹ️ Other conditions as applicable as per Bank Credit Policy. Bank reserves the right to
        review or withdraw the facility at any time without giving any reason. Scheme is
        applicable with effect from 1st August 2026.
      </div>

    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────
// MAHALAXMI THEV YOJNA DETAIL PAGE
// ─────────────────────────────────────────────────────────────────

const MahalaxmiDetail = ({ onBack }) => (
  <div className="sp-detail-page">

    <div className="sp-detail-hero-wrapper">
      <button className="sp-back-btn" onClick={onBack}>← Back to all schemes</button>
      <div>
        <div className="sp-badge">Scheme period: 9 Oct 2026 – 30 Nov 2026</div>
      </div>
      <h1 className="sp-detail-title">Mahalaxmi Thev Yojana</h1>
      <p className="sp-detail-subtitle">
        Special festive deposit scheme from The Sahyadri Sahakari Bank Ltd., Mumbai.
      </p>
    </div>

    <div className="sp-detail-content">

      <img
        src={MahalaxmiBanner}
        alt="Mahalaxmi Thev Yojana Banner"
        className="sp-banner-img"
        onError={(e) => (e.target.style.display = 'none')}
      />

      <div className="sp-metrics-grid">
        <div className="sp-metric-card">
          <div className="sp-metric-label">Rate of interest</div>
          <div className="sp-metric-value">7.60% p.a.</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Deposit period</div>
          <div className="sp-metric-value">21 Months</div>
        </div>
        <div className="sp-metric-card">
          <div className="sp-metric-label">Loan facility</div>
          <div className="sp-metric-value">Available</div>
        </div>
      </div>

      <div className="sp-section-card">
        <div className="sp-section-title">Scheme features</div>
        <SpFeatureRows data={mahalaxmiFeatures} />
      </div>

       {/* APPLY BUTTON */}
      <div className="sp-apply-wrapper">
        <a href="/loan-enquiry" className="sp-apply-btn">Apply Now</a>
      </div>

      <div className="sp-note-box">
        ℹ️ Scheme is applicable from 9th October 2026 to 30th November 2026.
      </div>

    </div>
  </div>
);

// ─────────────────────────────────────────────────────────────────
// MAIN SCHEMES PAGE
// ─────────────────────────────────────────────────────────────────

const SchemesPage = () => {
  const [activePage, setActivePage] = useState('listing');

  const handleSchemeClick = (id) => {
    setActivePage(id);
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    setActivePage('listing');
    window.scrollTo(0, 0);
  };

  // Show detail pages
  if (activePage === 'vyapari')  return <VyapariDetail  onBack={handleBack} />;
  if (activePage === 'suvasini') return <SuvasiniDetail onBack={handleBack} />;
  if (activePage === 'sukhakarta') return <SukhakartaDetail onBack={handleBack} />;
  if (activePage === 'navudyojak') return <NavudyojakDetail onBack={handleBack} />;
  if (activePage === 'mahalaxmi') return <MahalaxmiDetail onBack={handleBack} />;

  // Show listing page
  return (
    <div className="sp-page">

      {/* FULL WIDTH HERO */}
      <div className="sp-hero">
        <h1 className="sp-hero-title">Our Schemes</h1>
        <p className="sp-hero-subtitle">
          Explore our range of financial schemes designed to support your growth and aspirations.
        </p>
      </div>

      <div className="sp-content">

        {/* ACTIVE SCHEMES */}
        <div className="sp-section-label">Active schemes</div>
        <div className="sp-schemes-grid">
          {schemes.map((scheme) => (
            <SpSchemeCard
              key={scheme.id}
              scheme={scheme}
              onClick={() => handleSchemeClick(scheme.id)}
            />
          ))}
        </div>

        {/* UPCOMING SCHEMES */}
        {/* ✏️ Replace "New Scheme" text below with actual upcoming scheme names when ready */}
        <div className="sp-section-label">Upcoming schemes</div>
        <div className="sp-schemes-grid">
          <div className="sp-coming-soon-card">
            <div className="sp-coming-badge">⏳ Coming soon</div>
            <div className="sp-coming-name">New Scheme</div>
            <div className="sp-coming-desc">Details will be announced shortly. Stay tuned.</div>
          </div>
          <div className="sp-coming-soon-card">
            <div className="sp-coming-badge">⏳ Coming soon</div>
            <div className="sp-coming-name">New Scheme</div>
            <div className="sp-coming-desc">Details will be announced shortly. Stay tuned.</div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SchemesPage;